<div class="modal z-max" [class.is-active]="isVisible">
  <div class="modal-background"></div>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">{{ title }}</p>
    </header>
    <section class="modal-card-body" [innerHtml]="content"></section>
    <footer class="modal-card-foot">
      <button
        class="button"
        [class]="confirmBtnClass"
        [class.is-loading]="isLoading"
        (click)="onConfirmClick()"
      >
        {{ confirmBtnText }}
      </button>
      @if (canCancel) {
        <button
          class="button"
          (click)="onCancelClick()"
          type="button"
          [class.is-disabled]="isLoading"
        >
          Cancel
        </button>
      }
    </footer>
  </div>
</div>
